import { Button, Colors, IcArrowRight, IcCheckInFilled, IcPOS, Modal, Text } from '@fozito/common-ui';
import { SHOP_DEVICE_TYPE } from 'modules/POS/Cashier/cashier.constants';
import React, { forwardRef, useImperativeHandle, useRef, useState } from 'react';
import styled from 'styled-components';
type Props = {};
type Ref = {
  open: (storeId: string, cb: (result: SHOP_DEVICE_TYPE) => void) => void;
};
export const useModalDeviceTypeRef = () => useRef<Ref>(null);
const ModalDeviceType = forwardRef<Ref, Props>(({ }, ref) => {
  const [storeId, setOpen] = useState('');
  const cbRef = useRef<(result: SHOP_DEVICE_TYPE) => void>(() => undefined);

  const onClose = () => setOpen('');
  const onOpen: Ref['open'] = (_storeId, cb) => {
    setOpen(_storeId);
    cbRef.current = cb || (() => undefined);
  };
  const onChooseDevice = (type: SHOP_DEVICE_TYPE) => {
    cbRef.current(type);
    onClose();
  };

  useImperativeHandle(ref, () => ({
    open: onOpen
  }));

  return (
    <StyledModal title='DEVICE NUMBER' isOpen={!!storeId} onClose={onClose} width={900}>
      <StyledDevices>
        <div className='content'>
          <button
            className='button-choose-device'
            onClick={() => onChooseDevice(SHOP_DEVICE_TYPE.POS)}
          >
            <div className='device-item'>
              <div className='device-info'>
                <IcPOS width={80} height={80} fill={Colors.neutral.bg[6]} />
                <POS className='name-device'>POS</POS>
              </div>
              <IcArrowRight
                width={48}
                height={48}
                fill={Colors.neutral.bg[7]}
              />
            </div>
          </button>
          <button
            className='button-choose-device'
            onClick={() => onChooseDevice(SHOP_DEVICE_TYPE.SIGNATURE)}
          >
            <div className='device-item'>
              <div className='device-info'>
                <IcCheckInFilled width={80} height={80} fill={Colors.neutral.bg[6]} />
                <POS className='name-device'>CHECK-IN</POS>
              </div>
              <IcArrowRight
                width={48}
                height={48}
                fill={Colors.neutral.bg[7]}
              />
            </div>
          </button>
        </div>
      </StyledDevices>
      <StyledFooter>
        <Button
          type='button'
          type_cancel
          className='btn-close'
          onClick={onClose}
        >
          Close
        </Button>
      </StyledFooter>
    </StyledModal>
  );
});
ModalDeviceType.displayName = 'ModalDeviceType';
export default ModalDeviceType;

const StyledModal = styled(Modal)`
  width: 900px;
  background: #f5f5f5;
  max-width: 900px;
`;
const StyledDevices = styled.div`
  padding-top: 16px;
  .content {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px;
    padding: 0px 24px 40px 24px;

    & > :nth-child(odd):last-child {
      grid-column: span 2;
    }
  }
  button {
    &:hover {
      background: #eee;
      opacity: 0.8;
    }
  }
  .row-device {
    padding: 0 24px 40px;
  }

  .button-choose-device {
    width: 100%;
    padding: 0;
    box-shadow: 0px 4px 8px -3px #2d23424d, 0px 2px 4px 0px #2c234266;
  }

  .device-item {
    width: 100%;
    height: 164px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 24px 48px;
    border-radius: 4px;
    border: 1px solid #ccd4dc;
    box-shadow: 0px 2px 4px 0px rgba(44, 35, 66, 0.4),
      0px 4px 8px -3px rgba(45, 35, 66, 0.3), 0px -3px 0px 0px #d6d6e7 inset;
  }

  .device-info {
    display: flex;
    align-items: center;
    gap: 20px;
  }

  .name-device {
    font-size: 30px;
    font-family: 'Poppins';
    font-weight: 400;
    color: #1d2129;
  }
`;

const StyledFooter = styled.div`
  width: 100%;
  padding: 16px;
  background: #ffffff;
  box-shadow: 0px -4px 8px 0px rgba(0, 0, 0, 0.15);

  .btn-close {
    width: 100%;
  }
`;

const POS = styled(Text)`
  font-family: Poppins;
  font-weight: 400;
  font-size: 32px;
  line-height: 48px;
  letter-spacing: 0%;
  color: ${Colors.neutral.text[5]};
`;
